import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-invoice-type';
const API_DETAIL = (id: number) => `/p-crm-invoice-type/${id}`;

export interface PCrmInvoiceType {
  id: number;
  pit_descr?: string;
  pit_abbrev?: string | null;
}

export const usePCrmInvoiceTypes = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<PCrmInvoiceType[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    pCrmInvoiceTypes: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePCrmInvoiceType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<PCrmInvoiceType>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    pCrmInvoiceType: data,
    isLoading,
    isError: error,
    mutate,
  };
};
